import R from 'app/assets/R'
import { SvgTableCloseIcon } from 'app/assets/svg-assets'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { isEqual } from 'lodash'
import { ClinicTypeEnumList, DefineClinicType } from '../../type'
import { useModalHook } from './hook'
import * as S from './styles'
import { IPropsUpdateUnit, initValues } from './type'

export enum StatusUnitOptionsEnum {
  active = 'active',
  // error = 'error',
  inactive = 'inactive',
}

export const CreateUnitChild = (props: IPropsUpdateUnit) => {
  const {
    form,
    visible,
    t,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
    rules,
    unitGroups,
    unitTypes,
    jobTitles,
    type,
    onChangeClinicType,
  } = useModalHook(props)

  return (
    <BaseModalManagement
      isLoading={isLoading}
      typeButtonOpen="update"
      titleKeyI18n={R.strings.unit_content_create_unit_child}
      content={
        <BaseForm
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark="optional"
          initialValues={initValues}
          form={form}
        >
          <S.FormItem
            label={t(R.strings.unit_content_unit_parent)}
            name="parentid"
            rules={rules.parentid}
            hidden
            required
          >
            <S.FormInput disabled hidden />
          </S.FormItem>
          <BaseRow gutter={[16, 8]} align={'middle'}>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_content_unit_parent)}
                name="nameParent"
                required
              >
                <S.FormInput
                  disabled
                  placeholder={t(R.strings.enter_field, {
                    field: t(R.strings.unit_content_name_create),
                  })}
                />
              </S.FormItem>
            </BaseCol>
            <BaseCol xl={12}>
              <BaseRow
                gutter={[8, 8]}
                align={'middle'}
                justify={'space-between'}
              >
                <BaseCol xl={10}>
                  <S.FormItem
                    name="code"
                    label={t(R.strings.unit_content_id)}
                    rules={rules.code}
                    required
                  >
                    <S.FormInput
                      disabled
                      placeholder={t(R.strings.enter_field, {
                        field: t(R.strings.unit_content_id),
                      })}
                    />
                  </S.FormItem>
                </BaseCol>
                <BaseCol xl={14}>
                  <S.FormItem name="codeChildren" rules={rules.code}>
                    <S.FormInput
                      placeholder={t(R.strings.enter_field, {
                        field: t(R.strings.unit_content_id),
                      })}
                    />
                  </S.FormItem>
                </BaseCol>
              </BaseRow>
            </BaseCol>
          </BaseRow>
          <BaseRow gutter={[16, 8]} align={'middle'}>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_content_unitTypeId)}
                name="unitTypeId"
                rules={rules.unitTypeId}
                required
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings.unit_content_please_select_unitTypeId,
                  )}
                  suffixIcon={<SvgTableCloseIcon />}
                  onChange={id => onChangeClinicType(id as string)}
                  options={unitTypes?.map(unit => ({
                    value: unit?._id,
                    label: unit?.name,
                  }))}
                  showSearch
                />
              </S.FormItem>
            </BaseCol>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_content_unit_department)}
                name="unitGroupId"
                rules={rules.unitGroupId}
                required
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings.unit_content_please_select_unit_department,
                  )}
                  suffixIcon={<SvgTableCloseIcon />}
                  showSearch
                  options={unitGroups?.map(itm => ({
                    value: itm?._id,
                    label: itm?.name,
                  }))}
                />
              </S.FormItem>
            </BaseCol>
          </BaseRow>

          {isEqual(type?.toLowerCase(), 'Clinic'.toLowerCase()) ? (
            <S.FormItem
              label={t(R.strings.clinic_type)}
              name="clinicType"
              rules={rules.clinicType}
              required
            >
              <S.SelectBaseStyled
                placeholder={t(R.strings.select_clinic_type)}
                options={ClinicTypeEnumList?.map(type => ({
                  value: type,
                  label: t(DefineClinicType[type].keyI18n),
                }))}
                showSearch
              />
            </S.FormItem>
          ) : null}

          <BaseRow gutter={[16, 8]} align={'middle'}>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_content_job_title_management)}
                name="jobTitleIdManagement"
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings
                      .unit_content_please_select_unit_job_title_management,
                  )}
                  suffixIcon={<SvgTableCloseIcon />}
                  showSearch
                  options={jobTitles?.map(jobTitle => ({
                    value: jobTitle?._id,
                    label: jobTitle?.name,
                  }))}
                />
              </S.FormItem>
            </BaseCol>
            <BaseCol xl={12}>
              <S.FormItem
                label={t(R.strings.unit_field_job_title_vice)}
                name="jobTitleIdVice"
              >
                <S.SelectBaseStyled
                  placeholder={t(
                    R.strings.unit_content_please_select_unit_job_title_vice,
                  )}
                  showSearch
                  options={jobTitles?.map(jobTitle => ({
                    value: jobTitle?._id,
                    label: jobTitle?.name,
                  }))}
                />
              </S.FormItem>
            </BaseCol>
          </BaseRow>
          <S.FormItem
            name="name"
            label={t(R.strings.unit_content_name_create)}
            rules={rules.name}
            required
          >
            <S.FormInput
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.unit_content_name_create),
              })}
            />
          </S.FormItem>
          <S.FormItem
            name="description"
            label={t(R.strings.unit_content_description)}
            rules={rules.description}
            required
          >
            <S.FormInput.TextArea
              showCount
              maxLength={300}
              placeholder={t(R.strings.enter_field, {
                field: t(R.strings.unit_content_description),
              })}
            />
          </S.FormItem>
        </BaseForm>
      }
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.unit_content_create_unit_child}
      confirmKeyI18n={R.strings.unit_content_add}
      handleSubmit={form.submit}
      visible={visible}
    />
  )
}
